import { useMemo } from "react"
import dayjs from "config/dayjs"
import { useVenue } from "providers/venue"

export const useHome = () => {
  const { features, venues, locales, dataLoaded } = useVenue()

  const featuredEventPromotion = useMemo(
    () =>
      features
        .filter(
          ({ feature_type, properties }) =>
            ["promotion", "event"].includes(feature_type) &&
            properties.is_featured
        )
        .sort(
          (a, b) =>
            dayjs(a.properties.start_date).valueOf() -
            dayjs(b.properties.start_date).valueOf()
        ),
    [features]
  )

  const defaultItemsLinks = [
    {
      to: "/events",
      primaryText: "View All Event",
      secondaryText: "See more events that match your lifestyle",
      icon: "events",
    },
    {
      to: "/promotions",
      primaryText: "View All Promotion",
      secondaryText: "See more special deals and get special offers",
      icon: "promotions",
    },
  ]

  return {
    featuredEventPromotion,
    defaultItemsLinks,
    venues,
    locales,
    dataLoaded,
  }
}
